import { Injectable } from '@angular/core';
import { EventBus } from '../event-bus';

export type ProjectEventBusSignalREvents =
  | '[Project] issue-changed'
  | '[Project] comment-changed'
  | '[Project] workflow-changed'
  | '[Project] workflow-step-changed'
  | '[Project] updated'
  | '[Project] selected'
  | '[Project] scene-changed';

export type ProjectEventBusEvents =
  '[Project] updated' | '[Project] selected' | '[Project] file-uploaded';

/**
 * ProjectEventBus is responsible for emitting and listening to project SignalR events.
 * Provided on demand at the project route level so its lifetime matches the project context.
 */
@Injectable()
export class ProjectEventBus extends EventBus<
  ProjectEventBusSignalREvents | ProjectEventBusEvents
> {}
